import { render, staticRenderFns } from "./storeGoodsCategory.vue?vue&type=template&id=35961282&scoped=true&"
import script from "./storeGoodsCategory.vue?vue&type=script&lang=js&"
export * from "./storeGoodsCategory.vue?vue&type=script&lang=js&"
import style0 from "./storeGoodsCategory.vue?vue&type=style&index=0&id=35961282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35961282",
  null
  
)

component.options.__file = "storeGoodsCategory.vue"
export default component.exports